/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import throttle from 'lodash.throttle';
import ResizeObserver from 'resize-observer-polyfill';
export function useCellWidths(tableRef, containerRef) {
    const [cellWidths, setCellWidths] = useState([]);
    const updateCellWidths = () => {
        if (!tableRef.current)
            return;
        const cells = tableRef.current.querySelectorAll('tbody tr:first-child td');
        const widths = Array.from(cells).map((cell) => cell.getBoundingClientRect().width);
        setCellWidths(widths);
    };
    useEffect(() => {
        updateCellWidths();
    }, [tableRef.current]);
    // Update cell widths when container is resized.
    useEffect(() => {
        if (!containerRef.current)
            return;
        const resizeObserverCallback = throttle(updateCellWidths, 50); // Throttle events
        const resizeObserver = new ResizeObserver(resizeObserverCallback);
        resizeObserver.observe(containerRef.current);
        // eslint-disable-next-line consistent-return
        return () => resizeObserver.disconnect();
    }, [containerRef.current]);
    return cellWidths;
}
//# sourceMappingURL=useCellWidths.js.map